module.exports = __webpack_public_path__ + "static/image/font/pc/bmjua-3@3x.jpg?0889cf35";